export default 'icon--instagram';